<template lang="pug">
transition(name="fade")
  .LoadingOverlay
    .inner
      template(v-if="type === constants.LOADING_OVERLAY_TYPE.LABEL")
        .title {{ message }}
      template(v-else-if="type === constants.LOADING_OVERLAY_TYPE.LOAD_ASSETS")
        .title 読み込み中 {{loadedAssets.length}} / {{ queuedAssets.length }}
        .progress
          .progressBar(:style="{width: `${percentage}%`}")
</template>

<script>
import * as constants from '@/constants'

export default {
  name: 'km-loading-overlay',
  components: {},
  props: {
    type: {
      type: Number,
      default: constants.LOADING_OVERLAY_TYPE.LOAD_ASSETS
    },
    message: {
      type: String,
      default: ''
    },
    queuedAssets: {
      type: Array
    },
    loadedAssets: {
      type: Array
    }
  },
  data() {
    return {
      constants
    }
  },
  computed: {
    percentage() {
      const percentage =
        (this.loadedAssets.length / this.queuedAssets.length) * 100
      return percentage > 100 ? 100 : percentage
    }
  },
  methods: {
  },
  mounted() {
  },
  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.LoadingOverlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  align-items: center;
  justify-content: center;
  z-index: 1001;

  .inner {
    padding: 50px;
    font-size: 1.4rem;
    color: #aaa;
    text-align: center;
  }

  .title {
    display: block;
    margin: 0 0 10px 0;
  }

  .progress {
    width: 200px;
    height: 5px;
    background: #eee;

    .progressBar {
      width: 1px;
      height: 5px;
      background: orange;
    }
  }
}
</style>
